import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import LanguageContext from "../../helper/LanguageContext";
import { useSelector } from "react-redux";
import { callAPI } from "../../helper/apiUtils";
import { BASE_URL, KJUUP_COLORS } from "../../helper/constants";
import { $crud } from "../../helper/CrudFactory";
import { BranchPosition } from "../../Languages/vars/BranchPosition";
import { useHistory } from 'react-router-dom';
import CompanyRoles from "../Company/Dialogs/CompanyRoles";
import { SettingsStack } from "../../components/settings/SettingsList";
import { twoFactorRequest } from "../../helper/twoFactorApi";
import { $user } from "../../helper/UserFactory";
import ImageCropper from "./ImageCropper";
import "./EditProfile.css";
import { Oval } from 'react-loader-spinner'
import { getPersonalBranchPosition, loadCustomBranches } from '../../helper/customBranches';

function EditProfile() {

    const [profile, setProfile] = useState({
        fullName: "",
        firstName: '',
        lastName: '',
        avatar: '',
        title: '',
        buildingIndustryRole: ''
    })
    const [branchPosition, setBranchPosition] = useState(BranchPosition);
    const [errors, setErrors] = useState({
        fullName: "",
        firstName: '',
        lastName: '',
        avatar: '',
        title: '',
        buildingIndustryRole: ''
    });
    const { isGerm, strings } = React.useContext(LanguageContext);
    const user = useSelector(state => state.user)
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [isUploadingFile, setIsUploadFile] = useState(false)
    // The verified phone of the account (GET /user/profile carries none; GET /user/2fa
    // returns it, masked, once verified — as the mobile app reads it).
    const [verifiedPhone, setVerifiedPhone] = useState('')
    const tr = (key, de, en) => strings[key] || (isGerm ? de : en);

    // Back to where the page was opened from (the settings), as mobile goBack().
    const goBack = () => {
        if (history.length > 1) {
            history.goBack();
            return;
        }
        history.replace('/profile-setting');
    };

    useEffect(() => {
        let alive = true;
        twoFactorRequest('get', '/user/2fa').then((res) => {
            const phone = res && res.status && res.twoFactor && res.twoFactor.phoneVerified ? res.twoFactor.mobileNo : '';
            if (alive && typeof phone === 'string' && phone.trim()) setVerifiedPhone(phone.trim());
        });
        return () => { alive = false; };
    }, []);
    const getProfile = async () => {
        const { data: { profile } } = await callAPI(`/user/${user?.id}/profile`, {}, 'GET');
        setProfile(prev => {
            return {
                ...prev,
                fullName: profile?.fullName,
                title: profile?.title,
                firstName: profile?.firstName,
                lastName: profile?.lastName,
                avatar: profile?.avatar,
                buildingIndustryRole: profile?.buildingIndustryRole
            }
        })
        setIsUploadFile(false)
    }

    const setParam = (name, value) => {
        setProfile(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
        setErrors(prev => {
            return {
                ...prev,
                [name]: ''
            }
        });
    }
    const changeImage = async (file) => {
        console.log(file)
        if (file) {
            setIsUploadFile(true)
            let formData = new FormData()
            formData.append('file', file);
            $crud.put('/user/avatar', formData).then(res => {
                let userDetails = user
                userDetails.avatar = res.avatar
                $user.updateUserData(userDetails)
                getProfile();
            }).catch(() => {
                setIsUploadFile(false)
            })
            setShow(false);
        } else {
            $crud.notify({
                type: 'error',
                message: "Please select a file to upload"
            })
        }

    }

    useEffect(() => {
        getProfile();
    }, [user])
    useEffect(() => {
        loadCustomBranches().then(() => {
            setBranchPosition(getPersonalBranchPosition());
        });
    }, [])
    // Transform BranchPosition to match CompanyRoles structure (Roles -> branches)
    const transformedBranchPosition = branchPosition.map(category => ({
        ...category,
        branches: category.Roles || []
    }));
    
    const updateProfile = async () => {
        // Same checks as the mobile app (the API needs all three).
        const roles = String(profile.buildingIndustryRole || '').split(',').map((r) => r.trim()).filter(Boolean);
        if (!roles.length) {
            $crud.notify({ type: 'error', message: tr('pro_settings_profile_role_required', 'Bitte wähle deine Branche aus.', 'Please select your role in the building industry.') });
            return;
        }
        if (!String(profile.firstName || '').trim()) {
            $crud.notify({ type: 'error', message: tr('pro_settings_profile_first_name_required', 'Bitte gib deinen Vornamen ein.', 'Please enter your first name.') });
            return;
        }
        if (!String(profile.lastName || '').trim()) {
            $crud.notify({ type: 'error', message: tr('pro_settings_profile_last_name_required', 'Bitte gib deinen Nachnamen ein.', 'Please enter your last name.') });
            return;
        }
        setLoading(true)
        try {
            const { data } = await callAPI('/user/profile', {}, 'PUT', profile);
            if (!data.status) {
                await $crud.notify({
                    type: 'error',
                    message: data.message
                })
                return
            }
            // Persist edited fields so Profile can show them immediately
            // (even if a subsequent GET still returns briefly-stale data).
            // fullName on Profile is "title firstName lastName" (same as GET /user/profile).
            const existingProfile = $user.getUserProfile() || {}
            const recomputedFullName = [profile.title, profile.firstName, profile.lastName]
                .filter(Boolean)
                .join(' ')
                .replace(/\s+/g, ' ')
                .trim()
            const nextProfile = {
                ...existingProfile,
                ...profile,
                buildingIndustryRole: profile.buildingIndustryRole,
                fullName: recomputedFullName,
                firstName: profile.firstName,
                lastName: profile.lastName,
                title: profile.title || '',
                avatar: profile.avatar || existingProfile.avatar,
            }
            $user.updateUserData({ ...user, ...nextProfile })
            $user.setProfile({ profile: nextProfile })
            try {
                sessionStorage.setItem('pendingProfilePatch', JSON.stringify({
                    buildingIndustryRole: nextProfile.buildingIndustryRole,
                    fullName: nextProfile.fullName,
                    firstName: nextProfile.firstName,
                    lastName: nextProfile.lastName,
                    title: nextProfile.title,
                    avatar: nextProfile.avatar,
                }))
            } catch (e) { /* ignore */ }
            // Back to the settings (the retired /profile page only redirects to the start page).
            goBack()
        } finally {
            setLoading(false)
        }
    }
    const changeRole = roles => {
        const selectedRoles = roles.join(',')
        setParam('buildingIndustryRole', selectedRoles)
    }
    
    const handleRolesChange = (roles) => {
        const selectedRoles = roles.join(',')
        setParam('buildingIndustryRole', selectedRoles)
    }
    const [show, setShow] = useState(false);

    // Read-only account data (mobile EditProfilePro: the profile API saves name, roles
    // and title only). Username accounts carry a placeholder address: no e-mail then.
    const rawEmail = typeof user?.email === 'string' ? user.email.trim() : '';
    const readOnlyEmail = rawEmail && !/@(kjuup-user|user)\.com$/i.test(rawEmail) ? rawEmail : '';
    const ownPhone = typeof user?.mobileNo === 'string' ? user.mobileNo.trim() : (user?.mobileNo ? String(user.mobileNo) : '');
    const readOnlyPhone = ownPhone || verifiedPhone;
    const displayName = [profile.firstName, profile.lastName].filter(Boolean).join(' ') || profile.fullName || '';
    const initials = displayName
        .split(/\s+/)
        .filter(Boolean)
        .map((part, index, parts) => (index === 0 || index === parts.length - 1 ? part[0] : ''))
        .join('')
        .toUpperCase();
    const titleOptions = [
        { value: 'Dipl.-Ing.', label: strings.dep_ing },
        { value: 'Dr.', label: strings.dr },
        { value: 'Dr.-Ing.', label: strings.dr_ing },
        { value: 'Dipl.-Ing. Architect', label: strings.dep_ing_arc },
        { value: 'Prof.', label: strings.prof },
        { value: 'Dipl.-Kfm.', label: 'Dipl.-Kfm.' },
        { value: 'Dipl.-Kff.', label: 'Dipl.-Kff.' },
    ];

    return (
        <React.Fragment>
            <div className="edit-profile-page edit-profile ep-pro">
                <div className="page-header ep-pro__header">
                    <button
                        type="button"
                        className="kj-btn kj-btn--icon kj-btn--neutral ep-pro__back"
                        onClick={goBack}
                        aria-label={strings.close || tr('close', 'Schließen', 'Close')}
                    >
                        <span className="material-symbols-outlined">keyboard_arrow_left</span>
                    </button>
                    <h2 className="page-header-title">{tr('v2_profile_edit_title', 'Profil bearbeiten', 'Edit profile')}</h2>
                    <button
                        type="submit"
                        form="ep-pro-form"
                        className={`kj-btn kj-btn--primary kj-btn--sm${loading ? ' kj-btn--loading' : ''}`}
                        disabled={loading || isUploadingFile}
                    >
                        {tr('pro_settings_save', 'Speichern', 'Save')}
                    </button>
                </div>
                <div className="ep-pro__body">
                    <SettingsStack className="ep-pro__stack">
                        <form
                            id="ep-pro-form"
                            className="ep-pro__form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                updateProfile();
                            }}
                        >
                            <div className="ep-pro__hero">
                                <button
                                    type="button"
                                    className="ep-pro__avatar"
                                    onClick={() => setShow(true)}
                                    disabled={isUploadingFile}
                                    aria-label={tr('v2_profile_edit_photo', 'Foto bearbeiten', 'Edit photo')}
                                    title={tr('v2_profile_edit_photo', 'Foto bearbeiten', 'Edit photo')}
                                >
                                    <span className="ep-pro__avatar-inner">
                                        <span className="ep-pro__initials">{initials}</span>
                                        {profile.avatar ? <img className="ep-pro__avatar-img" src={BASE_URL + profile.avatar} alt="" /> : null}
                                        {isUploadingFile ? (
                                            <span className="ep-pro__avatar-busy">
                                                <Oval
                                                    height={30}
                                                    width={30}
                                                    color={KJUUP_COLORS.base_color}
                                                    visible={true}
                                                    ariaLabel='oval-loading'
                                                    secondaryColor={"#fff"}
                                                    strokeWidth={5}
                                                    strokeWidthSecondary={5}
                                                />
                                            </span>
                                        ) : null}
                                    </span>
                                    <span className="ep-pro__badge" aria-hidden="true">
                                        <span className="material-symbols-outlined">photo_camera</span>
                                    </span>
                                </button>
                            </div>

                            <label className="ep-pro__field">
                                <span className="ep-pro__label">{strings.first_name || tr('first_name', 'Vorname', 'First name')}</span>
                                <span className="ep-pro__input">
                                    <span className="material-symbols-outlined" aria-hidden="true">person</span>
                                    <input
                                        type="text"
                                        autoComplete="given-name"
                                        value={profile.firstName || ''}
                                        onChange={(e) => setParam('firstName', e.target.value)}
                                    />
                                </span>
                            </label>

                            <label className="ep-pro__field">
                                <span className="ep-pro__label">{strings.last_name || tr('last_name', 'Nachname', 'Last name')}</span>
                                <span className="ep-pro__input">
                                    <span className="material-symbols-outlined" aria-hidden="true">person</span>
                                    <input
                                        type="text"
                                        autoComplete="family-name"
                                        value={profile.lastName || ''}
                                        onChange={(e) => setParam('lastName', e.target.value)}
                                    />
                                </span>
                            </label>

                            <div className="ep-pro__field">
                                <span className="ep-pro__label">{strings.role_in_the_building_industry}</span>
                                <div className="add_company_from ep-pro__roles">
                                    <Form.Group className="select_coustom position-relative role-search-form-group">
                                        <CompanyRoles
                                            searchMode={true}
                                            selectedRoles={profile.buildingIndustryRole}
                                            hideRoles={() => {}}
                                            setRoles={() => {}}
                                            selectPosition={changeRole}
                                            position={transformedBranchPosition}
                                            onRolesChange={handleRolesChange}
                                        />
                                    </Form.Group>
                                </div>
                            </div>

                            <label className="ep-pro__field">
                                <span className="ep-pro__label">{strings.title}</span>
                                <span className="ep-pro__input ep-pro__select">
                                    <span className="material-symbols-outlined" aria-hidden="true">badge</span>
                                    <select value={profile.title || ''} onChange={(e) => setParam('title', e.target.value)}>
                                        <option value="">{tr('pro_settings_choose', 'Auswählen', 'Choose')}</option>
                                        {titleOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label || option.value}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="material-symbols-outlined ep-pro__select-arrow" aria-hidden="true">keyboard_arrow_down</span>
                                </span>
                            </label>

                            {readOnlyPhone ? (
                                <label className="ep-pro__field">
                                    <span className="ep-pro__label">{tr('pro_settings_phone', 'Telefon', 'Phone')}</span>
                                    <span className="ep-pro__input is-readonly">
                                        <span className="material-symbols-outlined" aria-hidden="true">call</span>
                                        <input type="text" value={readOnlyPhone} readOnly />
                                    </span>
                                </label>
                            ) : null}

                            {readOnlyEmail ? (
                                <label className="ep-pro__field">
                                    <span className="ep-pro__label">{tr('pro_settings_email', 'E-Mail', 'E-mail')}</span>
                                    <span className="ep-pro__input is-readonly">
                                        <span className="material-symbols-outlined" aria-hidden="true">mail</span>
                                        <input type="text" value={readOnlyEmail} readOnly />
                                    </span>
                                </label>
                            ) : null}
                        </form>
                    </SettingsStack>
                </div>
            </div>

            <>
                <Modal
                    show={show}
                    onHide={() => setShow(false)}
                    dialogClassName="avatar-picker-modal"
                    aria-labelledby="example-custom-modal-styling-title"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            {isGerm ? "Profilbild zuschneiden" : "Crop profile photo"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ImageCropper mode="profile" changeImage={changeImage} onClose={() => setShow(false)} />
                    </Modal.Body>
                </Modal>
            </>
        </React.Fragment>
    );
}

export default EditProfile;
